<template>
  <div>
    <validation-observer ref="holidayForm">
      <b-form @submit.prevent="handleSubmit">
        <b-row>
          <b-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="Nombre del festivo"
              rules="required"
            >
              <b-form-group
                label="Nombre del festivo"
                label-for="holiday-name"
              >
                <b-form-input
                  id="holiday-name"
                  v-model="form.name"
                  placeholder="Ej: Día de la Comunidad"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <validation-provider
              v-slot="{ errors }"
              name="Fecha"
              rules="required"
            >
              <b-form-group
                label="Fecha"
                label-for="holiday-date"
              >
                <b-form-input
                  id="holiday-date"
                  v-model="form.date"
                  type="date"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>

          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox
                v-model="form.is_recurring"
                switch
              >
                Festivo recurrente (se repite cada año)
              </b-form-checkbox>
            </b-form-group>
          </b-col>
        </b-row>

        <div class="text-right mt-2">
          <b-button
            variant="outline-primary"
            class="mr-1"
            @click="$emit('cancel')"
          >
            Cancelar
          </b-button>
          <b-button
            type="submit"
            variant="primary"
          >
            Añadir festivo
          </b-button>
        </div>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { mapActions } from 'vuex'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BButton,
  BRow,
  BCol,
} from 'bootstrap-vue'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BButton,
    BRow,
    BCol,
  },
  props: {
    calendarId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      form: {
        name: '',
        date: '',
        is_recurring: false,
      },
    }
  },
  methods: {
    ...mapActions({
      addHoliday: 'calendar/addHoliday',
      getCalendarData: 'calendar/getCalendar',
    }),
    async handleSubmit() {
      const valid = await this.$refs.holidayForm.validate()
      if (!valid) return

      const year = new Date(this.form.date).getFullYear()

      await this.addHoliday({
        id: this.calendarId,
        data: {
          ...this.form,
          year,
        },
      })

      await this.getCalendarData({ id: this.calendarId, year })

      this.$emit('success')
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
